<template>
  <div>
    <b-form>
      <span>
        School Address
      </span>
      <b-row>
        <b-col xs=12 md=4>
          <label class="text-gray-400">
            {{ value.street }}
          </label>
        </b-col>
        <b-col xs=12 md=2
          v-if="address.apartment">
          <label class="text-gray-400">
            {{ value.apartment }}
          </label>
        </b-col>
        <b-col sm=5 md=2>
          <label class="text-gray-400">
            {{ value.city }}
          </label>
        </b-col>
        <b-col sm=4 md=2>
          <label class="text-gray-400">
            {{ value.state }}
          </label>
        </b-col>
        <b-col sm=3 md=2> 
          <label class="text-gray-400">
            {{ value.zip_code }}
          </label>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <span class="text-xs">
            If this address is incorrect, please choose another option, or enter a new school or program name.
          </span>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
  },
  data() {
    return {
      address: {},
    }
  },
  methods: {
    setAddress() {
      this.address = this.value
    },
  }
}
</script>
